<template><div><h1 id="artikelbestande-pro-lager-export-fur-excel" tabindex="-1"><a class="header-anchor" href="#artikelbestande-pro-lager-export-fur-excel"><span>Artikelbestände pro Lager, Export für Excel</span></a></h1>
<p>Artikelbestände pro Lager, Export für Excel — gibt aktuellen Artikelbestand aus</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung &quot;Artikelbestände pro Lager&quot; zeigt den Lagerbestand eines bestimmten Artikels, Gesamtbestände aller Partien, die Bestellsituation sowie ergänzende Informationen aus dem Artikelstamm zum aktuellen Datum. Sie erstellt eine Datei im Excelformat und dient der Überprüfung relevanter Daten aus dem Artikelstamm und dem Einkauf.</p>
<p>Pfad: <code v-pre>Logistik → Auswertungen → Artikelbestände pro Lager</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Lager</dt>
<dd>Eingrenzung auf ein oder mehrere bestimmte Lager (mit Komma trennen, mit ! ausschliessen, * = alles, gibt man 0 ein, werden ebenfalls automatisch alle Lager verwendet.)</dd>
<dt>ArtGruppe von</dt>
<dd>Eingrenzung nach Artikelgruppe (von - bis)</dd>
<dt>PM von</dt>
<dd>Eingrenzung nach Productmanager (von - bis)</dd>
<dt>Merkmale separat</dt>
<dd>Angabe von bis zu 8 Personenmerkmalen möglich. Im Output werden die konkreten Merkmale angegeben, wenn sie beim Artikel vorhanden sind (in Excel kann danach sortiert werden)</dd>
<dt>Sortierung nach</dt>
<dd>A = Artikelnummer; P = Productmanager; G = Artikelgruppe</dd>
<dt>Ausgabe</dt>
<dd>Standard (Textdatei)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>ArtGrp</td>
<td>Artikelgruppe</td>
</tr>
<tr>
<td>ArtNum</td>
<td>Artikelnummer</td>
</tr>
<tr>
<td>ArtTyp</td>
<td>Artikeltyp</td>
</tr>
<tr>
<td>ArtBezeichnung</td>
<td>Artikelbezeichnung</td>
</tr>
<tr>
<td>ArtStatus</td>
<td>Artikelstatus</td>
</tr>
<tr>
<td>PM</td>
<td>Productmanager</td>
</tr>
<tr>
<td>EkPreis</td>
<td>Einkaufspreis (aus Artikelstamm)</td>
</tr>
<tr>
<td>VkPreis</td>
<td>Verkaufspreis (aus Artikelstamm)</td>
</tr>
<tr>
<td>MWSt-Code</td>
<td>MWST-Code gemäss Tabelle [MWST-Codes]</td>
</tr>
<tr>
<td>Satz</td>
<td>MWST-Satz, wie er in der Tabelle definiert ist</td>
</tr>
<tr>
<td>NeuerVP</td>
<td>Neuer Verkaufspreis (aus Artikelstamm)</td>
</tr>
<tr>
<td>Ab Datum</td>
<td>Neuer Preis gilt ab diesem Datum</td>
</tr>
<tr>
<td>Lagerbestand V</td>
<td>Verkaufbarer Bestand aller V-Partien am definierten Lager</td>
</tr>
<tr>
<td>V Gesamtbestand</td>
<td>Verkaufbarer Bestand insgesamt (unabhängig von Lager)</td>
</tr>
<tr>
<td>R Gesamtbestand</td>
<td>Bestand aller Retourpartien</td>
</tr>
<tr>
<td>D Gesamtbestand</td>
<td>Bestand aller Defektpartien</td>
</tr>
<tr>
<td>N Gesamtbestand</td>
<td>Bestand aller Nichtverkaufbaren Partien</td>
</tr>
<tr>
<td>M Gesamtbestand</td>
<td>Bestand aller Musterpartien</td>
</tr>
<tr>
<td>vorreserviert</td>
<td>Anzahl Vorreserviert (pro Artikel; nur wenn [Datum bis] = Tagesdatum</td>
</tr>
<tr>
<td>reserviert</td>
<td>Anzahl Reserviert (pro Artikel); nur wenn [Datum bis] = Tagesdatum</td>
</tr>
<tr>
<td>Bestellung</td>
<td>Anzahl der jüngsten zu erwartenden Bestellung (pro Artikel); nur wenn [Datum bis] = Tagesdatum</td>
</tr>
<tr>
<td>DatumBestellung</td>
<td>Datum der nächsten Bestellung (voraussichtliches Lieferdatum); nur wenn [Datum bis] = Tagesdatum</td>
</tr>
<tr>
<td>BestellTotal</td>
<td>Anzahl Artikel gesamthaft von allen Bestellungen pro Artikel</td>
</tr>
<tr>
<td>M1</td>
<td>Merkmal 1</td>
</tr>
<tr>
<td>M8</td>
<td>Merkmal 8</td>
</tr>
</tbody>
</table>
<p>Lager:    444,450
ArtGruppe von:  bis:
PM von:  bis:
Merkmale separat:
Sortierung: Artikelnummer</p>
<p>ArtGrp  ArtNum  ArtTyp  ArtBezeichnung  ArtStatus       PM      EkPreis VkPreis
MWST-Code       Satz    Neuer VP        ab Datum        Lagerbestand V  V Gesamt
bestand R Gesamtbestand D Gesamtbestand N Gesamtbestand M Gesamtbestand vorreser
viert   reserviert      Bestellung      DatumBestellung BestellTotal    M1
M2      M3      M4      M5      M6      M7      M8
.</p>
</div></template>


